import './../../index.css';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import hoc from '../../hoc.js';
import 'classnames';
import '@hh.ru/magritte-common-use-disabled';
import '@hh.ru/magritte-ui-badge';
import '../../IconDynamic-D_LIh_94.js';
import '../../Skeleton.js';
import '@hh.ru/magritte-ui-skeleton';

const VkSolidSize16Component = (props, ref) => (jsx("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("g", { children: jsx("path", { d: "M8.6252 12.3858C3.84195 12.3858 1.11368 9.10661 1 3.65002H3.39599C3.47469 7.65502 5.24105 9.35144 6.64018 9.70122V3.65002H8.89634V7.1041C10.278 6.95544 11.7294 5.38144 12.2191 3.65002H14.4752C14.0992 5.78369 12.5252 7.35769 11.4059 8.00478C12.5252 8.52946 14.3179 9.90236 15 12.3858H12.5165C11.9831 10.7243 10.654 9.43889 8.89634 9.264V12.3858H8.6252Z", fill: "var(--magritte-ui-icon-color)" }) }) }));
const VkSolidSize16 = hoc(forwardRef(VkSolidSize16Component), 'VkSolidSize16');

export { VkSolidSize16 as default };
//# sourceMappingURL=VkSolidSize16.js.map
